import {
  IMPORTS_UPDATE_DATA,
  IMPORTS_ENABLE_LOADING,
  IMPORTS_DISABLE_LOADING,
  IMPORTS_UPDATE_FILTER,
  IMPORTS_RESET_FILTER,
  IMPORTS_PAGINATION,
  IMPORTS_RESET_PAGINATION,
  IMPORTS_UPDATE_SELECTED_SHIPMENTS,
} from 'src/actions/constants';
import moment from 'moment';

const defaultState = {
  isLoading: true,
  appliedFilters: {
    fromDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
  },
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    // set pagination data once api get updated
    case IMPORTS_UPDATE_DATA: {
      return {
        ...state,
        importsData: action.data,
        pagination: {
          ...state.pagination,
          lastConsignmentIdPrev: action.data ? action.data.lastConsignmentIdPrev : 0,
          isNextPresent: action.data ? action.data.is_next_present : null,
          lastConsignmentIdNext: action.data ? action.data.lastConsignmentIdNext : 0,
          lastSortedColumnValuePrev: action.data ? action.data.lastSortedColumnValuePrev : 0,
          lastSortedColumnValueNext: action.data ? action.data.lastSortedColumnValueNext : 0,
        },
        selectedShipments: null,
      };
    }
    case IMPORTS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case IMPORTS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case IMPORTS_UPDATE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case IMPORTS_UPDATE_SELECTED_SHIPMENTS: {
      return {
        ...state,
        selectedShipments: action.data,
      };
    }
    case IMPORTS_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
      };
    }
    case IMPORTS_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case IMPORTS_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    default:
      return state;
  }
}
